module.exports = __webpack_public_path__ + "static/media/rating-star-empty.b471afcd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/citylink/rating-star-empty.svg
// module id = 688
// module chunks = 0